import { Button, Modal, Text } from '@ksyos/design-system';
import { formatString } from '@common/utils/formatString';
import { getSelectedLanguage } from '@frontend/translate';
import { useFrontendSettings } from '@frontend/utils/hooks/useFrontendSettings';

interface TimeoutProps {
    isOpen: boolean;
    isSessionExpired?: boolean;
    onExtendSession?: () => void;
    onLogoutUser?: () => void;
}

export function TimeoutModal({ isSessionExpired, isOpen, onLogoutUser, onExtendSession }: TimeoutProps) {
    const { frontendSettings } = useFrontendSettings();
    const { timeout: translateTimeout } = getSelectedLanguage();

    const maxSessionInMinutes = frontendSettings.sessionDurationMinutes;

    const modalTitle = isSessionExpired ? translateTimeout.titleLoggedOut : translateTimeout.titleSessionWarning;
    const modalMessage = isSessionExpired
        ? formatString(translateTimeout.messageLoggedOut, [maxSessionInMinutes.toString()])
        : formatString(translateTimeout.messageSessionWarning, [maxSessionInMinutes.toString()]);

    const buttonAction = isSessionExpired ? onLogoutUser : onExtendSession;
    const buttonText = isSessionExpired ? translateTimeout.login : translateTimeout.reset;

    return (
        <Modal
            closeOnEsc={false}
            data-no-focus-lock
            isOpen={isOpen}
            onClose={() => {}}
            size="medium"
        >
            <Modal.Header>{modalTitle}</Modal.Header>
            <Modal.Body>
                <Text>{modalMessage}</Text>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={buttonAction}>{buttonText}</Button>
            </Modal.Footer>
        </Modal>
    );
}
